import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Portal } from '@angular/cdk/portal';

import { ToolbarService } from './toolbar.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent implements OnInit, OnDestroy, AfterViewInit {
  toolbarLeftPortal: Portal<any> | null = null;

  private _unsubscribe: Subject<void> | null = null;

  @ViewChild('toolbar', { read: ElementRef, static: true })
  toolbarRef: any = null;

  constructor(
    public toolbarService: ToolbarService,
    private _cdr: ChangeDetectorRef
  ) {
    // Empty
  }

  ngOnInit() {
    this._unsubscribe = new Subject<void>();

    this.toolbarService.toolbarLeftPortal$
      .pipe(takeUntil(this._unsubscribe))
      .subscribe(() => {
        this._cdr.markForCheck();
      });
    this.toolbarService.toolbarCenterPortal$
      .pipe(takeUntil(this._unsubscribe))
      .subscribe(() => {
        this._cdr.markForCheck();
      });
  }

  ngOnDestroy() {
    this._unsubscribe?.next();
    this._unsubscribe?.complete();
  }

  ngAfterViewInit() {
    this.toolbarService.setToolbarRef(this.toolbarRef);
  }
}
